<template>
  <!-- <main-layout> -->
  <div class="mass-bg">
    <v-container fluid v-if="!isHidden">
      <div class="step-03">
      <h2>Confirm &amp; Check Data</h2>
      <v-row>
        <v-col cols="1" md="1">
          <v-text-field
                  outlined dense label="Prefix"
                  v-model="prefix"
                  persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="4">
          <v-text-field
                  outlined dense label="Campaign Name"
                  v-model="campaignName"
                  hint="If left empty, the Campaign names will use the Offer names"
                  persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
            cols="12"
            sm="4"
            md="4"
        >
          <h3>Selected Affiliates (Count: {{ this.affList().count }})</h3>
          <p class="selected">{{ this.affList().affiliatesList }}</p>
        </v-col>
        <v-col
            cols="12"
            sm="4"
            md="4"
        >
          <h3>Selected Offers (Count: {{ offerList().count }})</h3>
          <p class="selected">{{ this.offerList().offersList }}</p>
        </v-col>
        <v-col
            cols="12"
            sm="4"
            md="4"
        >
          <div v-if="campaignName || prefix">
            <h3>Campaign Name:</h3>
            <div v-for="name in campaignsArray">
              {{ name }}
            </div>
          </div>
          <div v-else>

            <h3>Campaign Name:</h3>
            <div v-for="item in this.offerList().listArray">
              <p class="selected list">{{item}}</p>
            </div>
          </div>
        </v-col>

        <v-col
            cols="12"
            sm="4"
            md="4"
        >
          <v-checkbox
            v-model="emailAff"
            label="Send an email to affiliates"
            color="primary"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col
            cols="12"
            sm="4"
            md="4"
        >
          <v-checkbox
            v-model="emailManager"
            label="Send an email to managers"
            color="primary"
            hide-details
          ></v-checkbox>
        </v-col>

        <v-col
            cols="12"
            sm="12"
            md="12"
        >
            <p>
              <span class="primary">{{ this.affList().count * this.offerList().count }}</span>
              Campaigns will be created. Proceed?
            </p>

            <div class="text-left">
              <v-btn
                  color="primary"
                  :loading="loading"
                  elevation="0"
                  large
                  medium
                  small
                  x-large
                  x-small
                  @click="createCampaigns"
                  v-on:click="isHidden = true"
              > Create Campaigns
              </v-btn>
            </div>
        </v-col>
      </v-row>
      </div>
      </v-container>

      <div v-show="this.getMultiplySelectAffiliates.length ===0">
        <p>
          Choose Affiliates
        </p>
      </div>

      <div v-show="this.getMultiplySelectOffers.length ===0">
        <p>
          Choose Offers
        </p>
      </div>

      <div v-show="this.result">
      <!-- <div class="mass-result"> -->
        <h2><i class="fas fa-check"></i> <span class="primary">{{ this.countCampaignsCreated }}</span> Campaigns created.</h2>

        <p>Campaign IDs: {{ this.result }}</p>

        <v-btn
            color="primary"
            :loading="loading"
            elevation="0"
            medium
            @click="this.affiliateCampaigns"
        > Go to created campaigns
        </v-btn>
    </div>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
      ></v-progress-circular>
    </div>
  </div>
  <!-- </main-layout> -->
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import store from '../../../store'
import {getCookie} from "@/helpers"
import MainLayout from "../../layouts/MainLayout"

export default {

  data() {
    return {
      loading: false,
      selected: 0,
      result: '',
      campaignName: '',
      prefix: '',
      countCampaignsCreated: '',
      isHidden: false,
      emailAff: false,
      emailManager: false,
      alert: {
        showAlert: false,
        title: 'Campaigns created.',
        type: 'success'
      }
    }
  },

  async mounted() {
  },
  components: {
    // MainLayout,
  },
  methods: {
    affiliateCampaigns() {
      this.$router.push('/affiliates/campaigns')
      location.reload()
    },
    affList() {
      let selectedAffiliates = this.getMultiplySelectAffiliates
      if (selectedAffiliates.length === 0) return {
        count: 0,
        affiliatesList: []
      }
      let selectedAffiliatesArr = selectedAffiliates[0].split(',')
      let selectedAffFinal = selectedAffiliatesArr.map(i => {
        let aff = (this.getAffiliatesProfileCO.data.filter(j => (j.id === Number(i))))[0]
        return {id: aff.id, name: aff.name}
      })
      let affiliatesList = selectedAffFinal.map(i => `${i.name} (${i.id})`).join('\n')
      return {
        count: selectedAffFinal.length,
        affiliatesList: affiliatesList
      }
    },
    offerList() {
      let selectedOffers = this.getMultiplySelectOffers
      if (selectedOffers.length === 0) return {
        count: 0,
        offersList: []
      }
      const selectedOffersNamesAndIds = selectedOffers.map(i => `${i.name}(${i.id})`)

      return {
        count: selectedOffersNamesAndIds.length,
        offersList: selectedOffersNamesAndIds.join('\n'),
        listArray: selectedOffersNamesAndIds
      }
    },
    async createCampaigns() {
      this.loading = true
      let expectAffiliates = this.getMultiplySelectAffiliates[0]
      let expectOffers = this.getMultiplySelectOffers
      if (!expectOffers) {
        await this.$dialog.info({
          text: `Input offer`,
          title: 'Mass campaigns'
        })
        this.loading = false
        return
      }
      if (!expectAffiliates) {
        await this.$dialog.info({
          text: `Input affiliates`,
          title: 'Mass campaigns'
        })
        this.loading = false
        return
      }
      let affiliatesList = expectAffiliates.split(',')
      let offersList = expectOffers.map(i => i.id)

      let expectCampaignsCreatedCount = Number(affiliatesList.length) * Number(offersList.length)
      let confirmCreateCampaigns = await ({
      })
      // let confirmCreateCampaigns = await this.$dialog.warning({
      //   text: `Create campaigns, expect create ${expectCampaignsCreatedCount} campaigns `,
      //   title: 'Mass campaigns'
      // })
      if (confirmCreateCampaigns) {
        const payload = {
          affiliates: this.getMultiplySelectAffiliates,
          offers: offersList,
          sendEmailAffiliate: this.emailAff,
          sendEmailManager: this.emailManager,
        }
        if (this.campaignName) {
          payload.name = this.campaignName;
        }
        if(this.prefix) {
          payload.prefix = this.prefix
        }
        let res = await store.dispatch('massCampaignsCreation/createMassCampaignsStore', payload)
        if (res) {
          this.result = res.result
          let campaignsCount = JSON.parse(res.result).length
          this.countCampaignsCreated = campaignsCount
          store.dispatch('alert/ALERT_SUCCESS', `${campaignsCount} Campaigns created`, {root: true});
        } else {
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
        }
        this.loading = false
      }
      this.loading = false
    },
    ...mapMutations('affiliates', ['saveMultiplySelectAffiliates']),
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
  },
  computed: {
    ...mapGetters('affiliates', ['getSflAffiliates_', 'getMultiplySelectAffiliates', 'getAffiliatesProfileCO']),
    ...mapGetters('offers', ['getOffers', 'getMultiplySelectOffers']),
    campaignsArray() {
      const length = this.affList().count * this.offerList().count;
      const arr =  Array(length).fill().map((_, index) => index + 1);
      return arr.map(i => {
        const numPart = this.campaignName ? `#${i}` : '';
        const offerPart = !this.campaignName ? this.offerList().listArray[(i - 1) % this.offerList().listArray.length] : '';
        return `${this.prefix} ${this.campaignName} ${offerPart} ${numPart}`;
      });
    },
  },
  watch: {
    getMultiplySelectAffiliates(){
      if (
              this.getMultiplySelectAffiliates
              && this.getMultiplySelectAffiliates.length
              && this.getMultiplySelectAffiliates.length === 1
      ) {
        this.prefix = `${this.getMultiplySelectAffiliates[0]} - `;
      }
      if (this.affList().count > 1) {
        this.prefix = ''
      }
    }
  }
}
</script>

<style scoped lang="sass">
 .list
  margin: auto
.search_btn_wrap
  .add_campaigns_btn
    color: var(--v-primary-darken5) !important

  .search_wrapper
    width: 250px
    padding-bottom: 15px
    background: white

.mass-bg
  background: #fff
  margin-top: 52px
  padding: 20px

p
  font-size: 14px
  font-weight: 600
  color: #555555
  &.selected
    color: var(--v-secondary-base)
    white-space: pre-wrap

span.primary
  font-size: inherit
  color: var(--v-primary-base)
  background: transparent !important

h2.span.primary
  font-size: inherit
  color: var(--v-primary-base)

svg.svg-inline--fa.fa-check.fa-w-16
  color: #2ED47A
</style>
